import UserManagementContainer from './UserManagementContainer';

export default UserManagementContainer;
